<s-app-layout 
  [headerConfig]="headerConfig"
  [sidebarConfig]="sidebarConfig"
  [breakpoint]="768"
  (navItemClick)="onNavItemClick($event)"
  (layoutChange)="onLayoutChange($event)">
  
  <div class="main-content">
    <!-- Router outlet for navigation -->
    <router-outlet></router-outlet>
  </div>
  
</s-app-layout>
